import { memo } from 'react';

import FilterIconSVG from '@/assets/filter-icon.svg?react';
import { Icon, IconProps } from '@/components/core';

const IFilterIcon = (props: Omit<IconProps, 'SVGComponent'>) => <Icon SVGComponent={FilterIconSVG} {...props} />;

export const FilterIcon = memo(IFilterIcon) as typeof IFilterIcon;
